import React from 'react';
import Link from 'gatsby-link';

export default function PCCoWorkingSpace() {
  return (
    <div className="p-hero -content -coworking">
      <div className="p-hero__body -content">
        <div className="p-content__panel">
          <div className="p-content__panel--info">
            <div className="p-content__panel--title">2F<br />CO-<br />WORKING<br />SPACE</div>
            <div className="p-content__panel--time-title">ご利用時間</div>
            <div className="p-content__panel--time">9:30-21:30</div>
          </div>
          <div className="p-content__panel--body">
            <p>
              2Fに広がるのはコワーキングスペース。<br />
              WiFi・電源・プリンター完備の環境で、心ゆくまで仕事に没頭できます。<br />
              <br />
              このフロアもレイアウトは自由に変更できるので、<br />
              デスクワーク以外にも小物作りやイベント利用も可能です。<br />
              <br />
              詳しい使い方は詳細をご覧ください。
            </p>
            <Link to="/coworkingspace" className="c-button -icon">詳しい使い方へ</Link>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/index/PCCoWorkingSpace.js